var PREFIX = "CSOUND.";
// ACTION TYPES
export var SET_CSOUND_PLAY_STATE = PREFIX + "SET_CSOUND_PLAY_STATE";
